module.exports = __webpack_public_path__ + "media/images/flags/32/Sweden-2f507f16d2a04faf46fc5d497ba2ba7c.png";